import React from 'react';
import { Outlet } from 'react-router-dom';
import Nav from '@/components/nav/LandingNav';
import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
html, body, div, span, applet, object, iframe,
h1, h2, h3, h4, h5, h6, p, blockquote, pre,
a, abbr, acronym, address, big, cite, code,
del, dfn, em, img, ins, kbd, q, s, samp,
small, strike, strong, sub, sup, tt, var,
b, u, i, center,
dl, dt, dd, ol, ul, li,
fieldset, form, label, legend,
table, caption, tbody, tfoot, thead, tr, th, td,
article, aside, canvas, details, embed,
figure, figcaption, footer, header, hgroup,
menu, nav, output, ruby, section, summary,
time, mark, audio, video {
	margin: 0;
	padding: 0;
	border: 0;
	font-size: 100%;
	font: inherit;
	vertical-align: baseline;
}
/* HTML5 display-role reset for older browsers */
article, aside, details, figcaption, figure,
footer, header, hgroup, menu, nav, section {
	display: block;
}
body {
	line-height: 1;
}
ol, ul {
	list-style: none;
}
blockquote, q {
	quotes: none;
}
blockquote:before, blockquote:after,
q:before, q:after {
	content: '';
	content: none;
}
table {
	border-collapse: collapse;
	border-spacing: 0;
}

.hover-effect .char {
  position: relative;
  height: 100%;
}

.hover-effect {
  font-kerning: none;
  position: relative;
}

.hover-effect--cursor-square .char {
  --opa: 0;
}

.hover-effect--cursor-square .char::after {
  content: '';
  width: 1ch;
  top: 0;
  left: 0;
  position: absolute;
  opacity: var(--opa);
}

.hover-effect--cursor-square .char::after {
  background: currentColor;
  height: 100%;
}

html, body, #root {
  width: 100%;
  max-width: 100vw;
  /* clip (not hidden) — hidden/auto create scroll containers that break
     position: sticky for descendants; clip clips without that side effect */
  overflow-x: clip;
  padding: 0;
  margin: 0;
  font-family: "Noto Sans", sans-serif;
  font-optical-sizing: auto;
  font-weight: 400;
  font-style: normal;
  font-variation-settings: "wdth" 100;
  font-synthesis: none;

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;


  --medium: 768px;
  --small: 500px;

  --greyr: 141, 141, 141;
  --grey: rgb(var(--greyr));

  --greenr: 20, 189, 110;
  --green: rgb(var(--greenr));

  --redr: 255, 88, 90;
  --red: rgb(var(--redr));

  --blackr: 0, 0, 0;
  --black: rgb(var(--blackr));

  --purpler: 77, 66, 216;
  --purple: rgb(var(--purpler));

  --whiter: 255, 255, 255;
  --white: rgb(var(--whiter));
  /* otherpurp #7844E3 */
}

.noto-sans {
  font-family: "DM Sans", sans-serif;
  font-optical-sizing: auto;
  font-weight: 400;
  font-style: normal;
  font-variation-settings:
    "wdth" 100;
}

.sans {
  font-family: "Special Gothic Expanded One", sans-serif;
  font-weight: 400;
  font-style: normal;
}

.serif {
  font-family: "Cormorant Garamond", serif;
  font-optical-sizing: auto;
  font-weight: 400;
  font-style: normal;
  letter-spacing: -0.02em;
}

#root {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

h1{
  font-size: 4rem;
  line-height: 1.2;
  .serif, &.serif{
    font-size: 4.5rem;
  }
}

a{
  text-decoration: none;
  color: var(--black);
  cursor: pointer;
}

button{
  background-color: var(--black);
  color: var(--white);
  border: 1px solid var(--black);
  outline: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}

.hover{
    transition-duration: all 0.3s ease!important;
    svg{
      transition-duration: 0.3s!important;
    }

    &:hover{
      transition-duration: all 0.3s ease !important;
      svg{
        transform: translateX(1px);
      }
      background-color: #eee;
    }

  }

`;

const MainLayout: React.FC = () => {
  return (
    <>
      <GlobalStyles/>
      <div>
        <Nav />
        <main>
          <Outlet />
        </main>
      </div>
    </>
  );
};


const PlainLayout: React.FC = () => {
  return (
    <>
      <GlobalStyles/>
      <div>
        <main>
          <Outlet />
        </main>
      </div>
    </>
  );
};


export {
  MainLayout,
  PlainLayout
};
